import { useRequestedProfiles } from 'data/profiles'
import { Table } from './Table'
import Text, { TextTypes } from 'Components/Ui-Kits/Text'
import { useAppTranslation } from 'i18n/hooks'

export const MaxIncreaseRequests = () => {
  const { profiles } = useRequestedProfiles()
  const { t } = useAppTranslation()

  return (
    <>
      <Text as="h2" type={TextTypes.HEADING_34}>
        {t('bidLimitRequests')}
      </Text>
      <Table items={profiles} />
    </>
  )
}
